<template>
  <v-card class="mx-auto mt-4 px-2">
    <v-card-title
      primary-title
      class="justify-center"
      style="word-break:break-word;"
    >
      {{ dependente.nome }}
    </v-card-title>

    <v-list two-line>
      <template v-for="info in listaInformacao">
        <cgi-cadastro-info-item
          :key="info.key"
          :customData="info"
        ></cgi-cadastro-info-item>

        <v-divider
          :key="'d' + info.key"
          inset
        ></v-divider>
      </template>
    </v-list>
    <v-btn
      color="primary"
      class="mb-2 mt-2"
      @click="getBeneficiosDependentes(dependente.codDependente)"
    >{{ locale[local].screen.cgiCardDependente.btnBenefits }}</v-btn>

    <v-dialog v-model="dialogBeneficioDependentes" width="900">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >{{ locale[local].screen.cgiCardDependente.benefits }}
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogBeneficioDependentes = false">{{ locale[local].screen.cgiCardDependente.btnClose }}</v-btn>
            
            </v-card-title
          >

          <v-container>
            <v-data-table
              :headers="headers"
              :items="beneficioDependentes"
              hide-default-header
              hide-default-footer
              disable-pagination
              class="elevation-1"
            >
            </v-data-table>
          </v-container>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>


  </v-card>
</template>

<script>
import Util from "@/components/api/Util";
import Service from "@/components/api/Service.js"

export default {
  inheritAttrs: false,
  data: () => ({
    service: new Service(),
    listaInformacao: [],
    util: new Util(),

    dialogBeneficioDependentes: false,

    headers: [
          { text: 'Tipo', value: 'tipo' },
          { text: 'Descrição', value: 'campo1' },
          { text: 'Campo 2', value: 'campo2' },
          { text: 'Campo 3', value: 'campo3' },
          { text: 'Campo 4', value: 'campo4' },
        ],

    beneficioDependentes: []

  }),
  props: {
    dependente: {
      type: Object,
      default: null
    }
  },

  methods: {
    formatDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      if (!year || !month || !day) return date;

      var dataFormatada = `${day}/${month}/${year}`;

      return dataFormatada;
    },

    async getBeneficiosDependentes (codDependente) {
      this.dialogBeneficioDependentes = true
      const response = await this.service.getBeneficiosDependentes(codDependente)
      this.beneficioDependentes = response?.data?.Beneficio ?? []
      console.log(this.beneficioDependentes)
      console.log(response)
    },

  },
  created () {
    var objDependencia = {
      key: 0,
      icon: "mdi-account-supervisor",
      value: this.$props.dependente.dependencia,
      description: "Dependência"
    };

    var objCPF = {
      key: 1,
      icon: "mdi-card-text",
      value: this.$props.dependente.cpf,
      description: "CPF"
    };

    var dataFormatada = this.formatDate(this.$props.dependente.dtNascimento);

    var objDataNascimento = {
      key: 2,
      icon: "mdi-calendar",
      value: dataFormatada,
      description: "Data de Nascimento"
    };

    var objCEP = {
      key: 3,
      icon: "mdi-map-marker",
      value:
        this.$props.dependente.nomeCidade +
        ", " +
        this.$props.dependente.codUf +
        " " +
        this.$props.dependente.codCep,
      description: "Endereco"
    };

    var objSexo = {
      key: 4,
      icon: "mdi-gender-male-female",
      value: this.$props.dependente.sexo,
      description: "Sexo"
    };

    var objMatricula = {
      key: 5,
      value: ` ${this.$props.dependente.numCertidao} / ${this.$props.dependente.livroCertidao} / ${this.$props.dependente.folhaCertidao} / ${this.$props.dependente.matriculaCertidao}`,
      description: "Número / Livro / Folha / Mátricula Certidão"
    };

    var objEstudante = {
      key: 6,
      icon: "mdi-bookshelf",
      value: this.$props.dependente.estudante,
      description: "Estudante"
    };

    var objMae = {
      key: 7,
      icon: "mdi-face-woman",
      value: this.$props.dependente.nomeMae,
      description: "Mãe"
    };

    var objPai = {
      key: 8,
      icon: "mdi-face",
      value: this.$props.dependente.nomePai,
      description: "Pai"
    };

    var objNecessidadeEspecial = {
      key: 9,
      icon: "mdi-wheelchair-accessibility",
      value: this.$props.dependente.necessidadeEspecial,
      description: "Necessidade Especial"
    };

    if (this.$props.dependente.objDependencia)
      this.listaInformacao.push(objDependencia);

    if (this.$props.dependente.cpf) this.listaInformacao.push(objCPF);

    if (this.$props.dependente.dtNascimento)
      this.listaInformacao.push(objDataNascimento);

    if (this.$props.dependente.codCep) this.listaInformacao.push(objCEP);

    if (this.$props.dependente.sexo) this.listaInformacao.push(objSexo);

    if (
      this.$props.dependente.numCertidao ||
      this.$props.dependente.livroCertidao ||
      this.$props.dependente.folhaCertidao ||
      this.$props.dependente.matriculaCertidao
    )
      this.listaInformacao.push(objMatricula);

    if (this.$props.dependente.estudante)
      this.listaInformacao.push(objEstudante);

    if (this.$props.dependente.nomeMae) this.listaInformacao.push(objMae);

    if (this.$props.dependente.nomePai) this.listaInformacao.push(objPai);

    if (this.$props.dependente.necessidadeEspecial)
      this.listaInformacao.push(objNecessidadeEspecial);
  },
  computed: {
    cardWidth () {
      //https://stackoverflow.com/questions/57041559/vuetify-breakpoints-for-columns
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return "400px";
        case "md":
          return "500px";
        case "lg":
          return "800px";
        case "xl":
          return "1000px";
        default:
          return "400px";
      }
    }
  }
};
</script>
